import PostDetail from '../../components/blog/detail';
import NotFound from '../../components/common/not-found';
import {
  getCustomTypeStaticPaths,
  getCustomTypeStaticProps,
  postDetailQuery,
  postPathQuery,
} from '../../lib/custom-type';

export default function Post({ customType: post, preview, related }) {
  if (!post) {
    // with fallback = true prerendering calls that page without any props... no idea why..
    return <NotFound preview={preview} />;
  }

  return <PostDetail post={post} preview={preview} related={related} />;
}

export const getStaticProps = async (props) =>
  await getCustomTypeStaticProps({
    ...props,
    gqlQuery: postDetailQuery,
    variables: { uid: props.params.post },
  });

export const getStaticPaths = async () =>
  await getCustomTypeStaticPaths(postPathQuery, 'post');
